import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { NavLink as NL } from 'react-router-dom';
import { getNewsCategories } from '../../../SHARED/actions/news.actions';
import { capitalizeFirstLetter, slugify } from '../../../SHARED/helpers/general.helper';
import {
    Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink,
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';

import {
    HOME_ROUTE,
    ROOT_ROUTE,
    ALL_MOVIES_ROUTE,
    // BOXOFFICE_ROUTE,
    SERIALS_ROUTE,
    MOVIE_THEATERS_ROUTE,
    SCHEDULE_ROUTE_WITHOUT_PARAMS,
    RECENT_MOVIES_ROUTE,
    SOON_IN_CINEMA_ROUTE,
    GENERAL_NEWS_ROUTE,
/*    ALL_NEWS_ROUTE,
    EDITORIAL_NEWS_ROUTE,
    CHRONICS_NEWS_ROUTE,
    PORTRET_NEWS_ROUTE,
    FESTIVAL_NEWS_ROUTE, */
    FESTIVAL_PAGE_ROUTE,
    TIKETS_ROUTE,
    ABOUT_PROJECT,
    ALL_NEWS_ROUTE,
    SERIALS_NEWS_ROUTE
} from '../../../SHARED/config/routes';

class MainMenu extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
            selectedDropdown: '',
        };
    }

    toggle(clickedRoute) {
        if(this.props.location.pathname !== clickedRoute) {
            this.setState({
                isOpen: !this.state.isOpen,
                selectedDropdown: ''
            });
        }
    }

    goTo(url) {
        this.toggle(url);
        this.props.history.push(url);
    }

    componentWillMount() {
        this.props.getNewsCategories();
    }

    getNewsMenuItems = () => {
        return this.props.newsCategories.map((item, i) => {
            const slug = slugify(item.name);
            if(slug !== 'seriale') {
                return <DropdownItem tag="a" key={i}>
                            <div className={this.checkSubmenuState('/stiri/' + slug)} onClick={() => this.goTo('/stiri/' + slug)}>
                                { capitalizeFirstLetter(item.name) }
                            </div>
                        </DropdownItem>
            }

        });
    };

    checkSubmenuState = (route) => {
        return this.props.location.pathname === route ? 'active' : '';
    };

    render() {
        return (
            <div className="mainMenu">
                <Navbar color="light" light expand="lg" className="nopadding">
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <NL activeClassName="activelink" exact to={ROOT_ROUTE} onClick={() => this.toggle(ROOT_ROUTE)}>Home</NL>
                            </NavItem>
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret className={this.state.selectedDropdown === 1 ? 'activelink' : ''}>
                                    Filme
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem tag="a">
                                        <div className={this.checkSubmenuState(RECENT_MOVIES_ROUTE)} onClick={() => this.goTo(RECENT_MOVIES_ROUTE)}>
                                            Recente
                                        </div>
                                    </DropdownItem>
                                    <DropdownItem tag="a">
                                        <div className={this.checkSubmenuState(SOON_IN_CINEMA_ROUTE)} onClick={() => this.goTo(SOON_IN_CINEMA_ROUTE)}>
                                            În curând în cinema
                                        </div>
                                    </DropdownItem>
                                    <DropdownItem tag="a">
                                        <div className={this.checkSubmenuState(ALL_MOVIES_ROUTE)} onClick={() => this.goTo(ALL_MOVIES_ROUTE)}>
                                            Toate filmele
                                        </div>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret className={this.state.selectedDropdown === 2 ? 'activelink' : ''}>
                                    Program Cinema
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem tag="a">
                                        <div className={this.checkSubmenuState(MOVIE_THEATERS_ROUTE)} onClick={() => this.goTo(MOVIE_THEATERS_ROUTE.replace(':slug',slugify(this.props.selectedCinemaLocation)))}>
                                            Cinematografe
                                        </div>
                                    </DropdownItem>
                                    <DropdownItem tag="a">
                                        <div className={this.checkSubmenuState(SCHEDULE_ROUTE_WITHOUT_PARAMS)} onClick={() => this.goTo(SCHEDULE_ROUTE_WITHOUT_PARAMS)}>
                                            Program
                                        </div>
                                    </DropdownItem>
                                    <DropdownItem tag="a">
                                        <div className={this.checkSubmenuState(TIKETS_ROUTE)} onClick={() => this.goTo(TIKETS_ROUTE)}>
                                            Bilete
                                        </div>    
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>

                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret className={this.state.selectedDropdown === 3 ? 'activelink' : ''}>
                                    Știri
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem tag="a">
                                        <div className={this.checkSubmenuState(ALL_NEWS_ROUTE)} onClick={() => this.goTo(ALL_NEWS_ROUTE)}>
                                            Toate
                                        </div>                        
                                    </DropdownItem>
                                    { this.getNewsMenuItems() }
                                    {/*<DropdownItem tag="a">
                                        <div onClick={() => this.goTo(ALL_NEWS_ROUTE)}>
                                            Toate
                                        </div>                        
                                    </DropdownItem>
                                    <DropdownItem tag="a">
                                        <div onClick={() => this.goTo(EDITORIAL_NEWS_ROUTE)}>
                                            Editorial
                                        </div>  
                                    </DropdownItem>
                                    <DropdownItem tag="a">
                                        <div onClick={() => this.goTo(CHRONICS_NEWS_ROUTE)}>
                                            Cronici
                                        </div> 
                                    </DropdownItem>
                                    <DropdownItem tag="a">
                                        <div onClick={() => this.goTo(PORTRET_NEWS_ROUTE)}>
                                            Portret
                                        </div> 
                                    </DropdownItem>
                                    <DropdownItem tag="a">
                                        <div onClick={() => this.goTo(FESTIVAL_NEWS_ROUTE)}>
                                            Festival
                                        </div> 
                                    </DropdownItem>*/}
                                </DropdownMenu>
                            </UncontrolledDropdown>

                            {/* <NavItem>
                                <NL activeClassName="activelink" to={BOXOFFICE_ROUTE} onClick={() => this.toggle(BOXOFFICE_ROUTE)}>Box Office</NL>
                            </NavItem> */}
                            <NavItem>
                                <NL activeClassName="activelink" to={FESTIVAL_PAGE_ROUTE} onClick={() => this.toggle(FESTIVAL_PAGE_ROUTE)}>Festival</NL>
                            </NavItem>
                            <NavItem>
                                <NL activeClassName="activelink" to={SERIALS_NEWS_ROUTE} onClick={() => this.toggle(SERIALS_NEWS_ROUTE)}>Seriale</NL>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    newsCategories: state.news.newsCategories,
    selectedCinemaLocation: state.filters.selectedCinemaLocation
});
export default withRouter(connect(mapStateToProps, {getNewsCategories})(MainMenu));



// WEBPACK FOOTER //
// ./src/FO/components/mainmenu/mainmenu.component.js